module.exports = __webpack_public_path__ + "img/BI3.2c15e215.png";